import { Alert, Snackbar, type AlertColor } from '@mui/material';
import type { SyntheticEvent } from 'react';

interface FeedbackSnackbarProps {
  open: boolean;
  message: string;
  severity?: AlertColor;
  onClose: () => void;
  autoHideDuration?: number;
}

/**
 * Lightweight transient notification (the app has no toast library) — an MUI
 * Snackbar wrapping an Alert. Used for reallocation/save confirmations.
 */
export const FeedbackSnackbar = ({
  open,
  message,
  severity = 'success',
  onClose,
  autoHideDuration = 4000,
}: FeedbackSnackbarProps) => {
  const handleClose = (_: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return;
    onClose();
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};
